<div class="container">
  <app-title-header [rescheduling]="rescheduling"></app-title-header>

  <section class="card">
    @if (isClientLocation && displayLocationEdit) {
    <div>
      <h2 class="h2-title">Location</h2>
      <mat-form-field class="fill" data-testid="timezoneSelector">
        <input
          matInput
          type="text"
          [value]="newLocation"
          (keyup)="onLocationChanged($event)"
        />
      </mat-form-field>
      @if (locationGuideline.trim().length > 0) {
      <span
        class="location-guidelines-container"
      >
        <div class="location-guidelines">
          <div class="location-guidelines-label">Location Guidelines:</div>
          {{ locationGuideline.trim() }}
        </div>
      </span>
      }
    </div>
    }
    <div class="calendar-header">
      <!-- Original Client Choice Selection -->
      <div class="team-member-select">
        @if ((teamMemberList$ | async)?.length > 1 && (isClientChoiceMeeting$ | async)) {
        <mat-form-field
          appearance="outline"
          class="team-member-select-box"
        >
          <mat-label>Select Staff</mat-label>
          <mat-select
            [value]="selectedHost"
            (selectionChange)="changeSelectedHost($event)"
          >
            <mat-option [value]="'any'">
              <span
                class="any-option-label"
                i18n="MEETING_ACTION.DIALOG.TEAM_MEMBER.ANY"
                >--- Any ---</span
              >
            </mat-option>
            @for (teamMember of teamMemberList$ | async; track teamMember.userId) {
            <mat-option
              [value]="teamMember.userId"
            >
              {{ teamMember.displayName }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        @if (!((teamMemberList$ | async)?.length > 1 && (isClientChoiceMeeting$ | async) && !selectedHost)) {
        <h2
          class="h2-title"
          i18n="@@CALENDAR.SELECT_DATE_TIME"
        >
          Select a date and time
        </h2>
        }
      </div>
      <div class="timezone-selector">
        <mat-form-field class="fill" data-testid="timezoneSelector">
          <mat-label>Timezone</mat-label>
          <input
            data-testid="timezoneAutocomplete"
            type="text"
            matInput
            [formControl]="timezoneControl"
            [matAutocomplete]="auto"
          />
          <mat-icon matSuffix (click)="clearInput()" class="clear-icon"
            >clear</mat-icon
          >
        </mat-form-field>

        <mat-autocomplete #auto="matAutocomplete">
          @for (option of timezoneOptions$ | async; track timeOptionTrack($index, option)) {
          <mat-option
            (onSelectionChange)="onTimeZoneChanged($event)"
            [value]="option.timezone"
            >{{ option.display }}</mat-option
          >
          }
        </mat-autocomplete>
      </div>
    </div>

    <div
      class="time-slots-row"
      [ngClass]="{
        blurred:
          ((teamMemberList$ | async)?.length > 1 &&
            (isClientChoiceMeeting$ | async) &&
            !selectedHost) ||
          (isTimeSlotLoading$ | async)
      }"
    >
      <div class="column calendar-column">
        <mat-calendar
          #displayCalendar
          data-testid="meeting-scheduler-calendar"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [dateFilter]="dateFilter"
          [selected]="dateSelected"
          (selectedChange)="dateSelected = $event"
        ></mat-calendar>
        @switch (currentView) {
          @case ('no-available-dates') {
            <div
              data-testid="no-available-dates"
              class="empty-message calendar-message"
              i18n="@@CALENDAR.NO_TIMES_AVAILABLE"
            >
              There are no times available for these dates
            </div>
          }
          @case ('loading') {
            <div
              data-testid="loading-case"
              class="empty-message calendar-message loading-overlay"
              i18n="@@CALENDAR.LOADING"
            >
              Loading...
            </div>
          }
          @case ('error') {
            <div
              data-testid="time-slots-error"
              class="empty-message calendar-message"
              i18n="@@CALENDAR.ERROR_OCCURRED_LOADING_TIMES"
            >
              An error occurred loading the meeting times
            </div>
          }
        }
      </div>

      <div class="column time-slots-column">
        @switch (currentView) {
          @case ('select-a-date') {
            <div
              data-testid="select-a-date"
              class="empty-message start-state"
              [@fadeSwapOut]
              i18n="@@CALENDAR.SELECT_DATE_TO_SHOW_TIMES"
            >
              Select a date to show times available
            </div>
          }
          @case ('select-a-time') {
            <div
              class="selected-date-time-slots"
              [@slideInOut]="dateSelected"
            >
              <div class="selected-date" data-testid="selected-date">
                <button
                  mat-icon-button
                  (click)="dateSelected = null"
                  class="back-button"
                >
                  <mat-icon>arrow_back</mat-icon>
                </button>
                {{ dateSelected | date : 'fullDate' }}
              </div>
              <ol data-testid="time-slot-list">
                @for (timeSlot of timeSlotsForDateSelected; track timeSlotTrackBy($index, timeSlot); let idx = $index) {
                <li
                  data-testid="time-slot-list-item"
                >
                  @if (this.selectedTimeSlot !== idx) {
                  <button
                    mat-stroked-button
                    class="time-slot-button"
                    data-testid="time-slot-button"
                    (click)="onTimeSlotSelected(idx, timeSlot)"
                  >
                    {{
                      timeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
                    }}
                  </button>
                  } @else {
                  <button
                    mat-flat-button
                    color="primary"
                    style="width: 100%"
                    data-testid="time-slot-button"
                  >
                    {{
                      timeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
                    }}
                  </button>
                  }
                </li>
                }
              </ol>
            </div>
          }
        }
      </div>
    </div>
  </section>

  <div class="confirm-button-component">
    @if (navigationService.canGoBack()) {
    <button
      class="back-link"
      mat-stroked-button
      (click)="navigationService.goBack()"
    >
      Back
    </button>
    }
    <button
      class="confirm-button"
      [disabled]="isConfirmButtonDisabled"
      mat-flat-button
      color="primary"
      (click)="onConfirmChanges()"
    >
      Confirm
    </button>
  </div>
</div>
